import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class UserActivityUseCase {
    constructor(data) {
        this.data = data;
    }
    run(data) {
        return this.data.trackUserActivity(data);
    }
}
UserActivityUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserActivityUseCase_Factory() { return new UserActivityUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: UserActivityUseCase, providedIn: "root" });
